import { reactive } from 'vue';

export type ToastType = 'error' | 'warning' | 'info';

/** A link shown after the message, for a toast that points at the docs. */
export interface ToastLink {
    href: string;
    label: string;
}

export interface Toast {
    id: number;
    message: string;
    type: ToastType;
    link?: ToastLink;
}

export interface ToastOptions {
    link?: ToastLink;
    /** How long the toast stays, in ms. A toast with a link to follow gets longer. */
    duration?: number;
}

let nextId = 0;
const TOAST_DURATION_MS = 5000;

export const toasts: Toast[] = reactive([]);

export function showToast(message: string, type: ToastType = 'error', options: ToastOptions = {}) {
    const msg = typeof message === 'string' && message ? message : 'An unexpected error occurred.';
    // Don't stack duplicates: if this exact message is already visible, reset nothing
    // (just let the existing one time out).
    if (toasts.some((t) => t.message === msg && t.type === type)) return;

    const id = ++nextId;
    toasts.push({ id, message: msg, type, link: options.link });
    setTimeout(() => dismissToast(id), options.duration || TOAST_DURATION_MS);
}

export function dismissToast(id: number) {
    const idx = toasts.findIndex((t) => t.id === id);
    if (idx !== -1) toasts.splice(idx, 1);
}
